/** Backend lock type for an assessment guide level (matches the `ContentLock` source types). */
export const GUIDE_LEVEL_LOCK_TYPE = 'guide_level';
